// extracted by mini-css-extract-plugin
export default {"uniBox-additional":"uniBox-additional__xUPD_"};